import { DeleteIcon, EditIcon } from "../../assets/icons/Svgs";

export const HorarioCard = ({ horario, index, onDelete, onEdit }) => {
  const {
    idHorario,
    horaInicio = "--:--",
    horaFin = "--:--",
    dia = {},
  } = horario;

  const cellClass = "border-r border-slate-200 border-t font-medium";
  const lastCellClass = "border-slate-200 border-t";

  return (
    <tr className="bg-white hover:bg-gray-100 transition-colors duration-300 text-sm text-gray-700 whitespace-nowrap [&>td]:p-3">
      <td className={cellClass}>{index}</td>
      <td className={cellClass}>{horaInicio}</td>
      <td className={cellClass}>{horaFin}</td>
      <td className={cellClass}>{dia.nombre || "N/D"}</td>
      <td className={lastCellClass}>
        <div className="flex justify-center gap-3">
          <button
            onClick={() => onDelete?.(idHorario)}
            className="text-red-600 hover:text-red-800"
            title="Eliminar horario"
            aria-label="Eliminar horario"
          >
            <DeleteIcon className="w-5 h-5" />
          </button>
          <button
            onClick={() => onEdit?.(idHorario)}
            className="text-blue-600 hover:text-blue-800"
            title="Editar horario"
            aria-label="Editar horario"
          >
            <EditIcon className="w-5 h-5" />
          </button>
        </div>
      </td>
    </tr>
  );
};
